import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  isInContext,
  onComplete,
  closeWindow,
} from '../utility/inContextDonation';
import _get from 'lodash/get';
import ConfirmationReturnText from './ConfirmationReturnText';

const getTransactionDetails = (data) => {
  return {
    tx: data.txn_id,
    st: data.payment_status,
    amt: data.mc_gross,
    cc: data.mc_currency,
    cm: data.custon_node,
    item_number: data.item_number,
    item_name: data.item_name,
  };
};

function ConfirmationInContext(props) {
  useEffect(() => {
    if (isInContext()) {
      const postBackData = _get(props.postBackData, 'postBackData');
      const transactionDetails = getTransactionDetails(postBackData);
      onComplete(transactionDetails);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      closeWindow();
    }, 5000);
  }, []);

  return <ConfirmationReturnText returnText={props.returnText} />;
}

ConfirmationInContext.propTypes = {
  postBackData: PropTypes.object,
  returnText: PropTypes.string,
};

export default ConfirmationInContext;
